import { render, staticRenderFns } from "./configuration-state.component.vue?vue&type=template&id=80552250&scoped=true"
import script from "./configuration-state.component.vue?vue&type=script&lang=ts"
export * from "./configuration-state.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80552250",
  null
  
)

export default component.exports